/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Lastupdatedlabel2Inputs */

const id_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir Diperbarui:`)
};

const ms_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas Kini Terakhir:`)
};

const da_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst Opdateret:`)
};

const de_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert:`)
};

const en_us2_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated:`)
};

const es_es2_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const es_mx2_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const fil_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling Na-update:`)
};

const fr_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour :`)
};

const it_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento:`)
};

const hu_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó frissítés:`)
};

const nl_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt:`)
};

const no_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist oppdatert:`)
};

const pl_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja:`)
};

const pt_br2_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const pt_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const ro_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizare:`)
};

const fi_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty:`)
};

const sv_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad:`)
};

const vi_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lần cuối:`)
};

const tr_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Güncelleme:`)
};

const cs_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktualizace:`)
};

const bg_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна актуализация:`)
};

const ru_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление:`)
};

const uk_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останнє оновлення:`)
};

const ar_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث:`)
};

const hi_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट:`)
};

const th_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตล่าสุด:`)
};

const ja_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新：`)
};

const zh_cn2_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新:`)
};

const zh_hant1_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後更新：`)
};

const ko_sandboxes_lastupdatedlabel2 = /** @type {(inputs: Sandboxes_Lastupdatedlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 업데이트:`)
};

/**
* | output |
* | --- |
* | "Last Updated:" |
*
* @param {Sandboxes_Lastupdatedlabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_lastupdatedlabel2 = /** @type {((inputs?: Sandboxes_Lastupdatedlabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Lastupdatedlabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "ms") return ms_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "da") return da_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "de") return de_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "fil") return fil_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "fr") return fr_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "it") return it_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "hu") return hu_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "nl") return nl_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "no") return no_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "pl") return pl_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "pt") return pt_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "ro") return ro_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "fi") return fi_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "sv") return sv_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "vi") return vi_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "tr") return tr_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "cs") return cs_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "bg") return bg_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "ru") return ru_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "uk") return uk_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "ar") return ar_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "hi") return hi_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "th") return th_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "ja") return ja_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_lastupdatedlabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_lastupdatedlabel2(inputs)
	return ko_sandboxes_lastupdatedlabel2(inputs)
});
export { sandboxes_lastupdatedlabel2 as "sandboxes.lastUpdatedLabel" }